exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-study {\n  background-color: #17bafb; }\n\n.chaining-group > .row {\n  overflow-x: auto;\n  white-space: nowrap;\n  display: inherit; }\n\n.chaining-group > .row > .col-sm-4 {\n  display: inline-block;\n  float: none; }\n\n.chaining-break {\n  word-wrap: break-word;\n  white-space: -moz-pre-wrap;\n  white-space: pre-wrap; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/shared/overview/overview.component.scss
// module id = ../../../../../src/app/shared/overview/overview.component.scss
// module chunks = main